import {
    IDynamicContentSlide,
    MinimumSlideInformation,
    PauseScreenOption,
    Slide,
    SlideDetails,
    SlideType
} from "@pcp/core/interfaces";
import { isTextBoard } from "./slide-type-checks";
import { replaceQueryParamsWith } from "./url";

//TODO: move "replaceSignatureUrls" method into a new service inside "shared/core/services" folder. Use 'PUBLIC_BLOB_URL' token to instantiate the service.
/**
 * append Signature for the Blob Storage to the slide's `imageResource` and `imageVariants` URLs
 */
export function replaceSignatureUrls<TSlide extends MinimumSlideInformation | SlideDetails | PauseScreenOption | IDynamicContentSlide>
(origSlide: TSlide, sas: string, publicUrl = ''): TSlide {
    const isPublic = (url: string): boolean => !!publicUrl && url.indexOf(publicUrl) > -1;
    const replaceWithSasIfNotPublic = (url: string): string => {
        //TODO: rest this in beanmer side:

        if (!url) {
            return '';
        }
        return isPublic(url) ? url : replaceQueryParamsWith(url, sas)
    };

    if (origSlide && 'type' in origSlide && origSlide.type === SlideType.driverscam) {
        return origSlide;
    }

    if (sas === '') {
        console.warn('Setting to an empty signature for slide', origSlide);
    }

    const slide = { ...origSlide } as TSlide;
    if ('imageVariants' in slide) {
        const imageVariants: Record<string, string> = {};
        Object.keys(slide.imageVariants).forEach(key => {
            imageVariants[key] = replaceWithSasIfNotPublic((slide as SlideDetails).imageVariants[key]);
        });
        slide.imageVariants = imageVariants;
    }

    if ('previewpicture' in slide && typeof slide.previewpicture === 'object') {
        slide.previewpicture = {
            thumb_n: replaceWithSasIfNotPublic(slide.previewpicture.thumb_n),
            thumb_h: replaceWithSasIfNotPublic(slide.previewpicture.thumb_h)
        };
    }

    if ('imageResource' in slide) {
        slide.imageResource = replaceWithSasIfNotPublic(slide.imageResource);
    }

    if ('bookpages' in slide) {
        slide.bookpages = slide.bookpages?.map(bp => ({
            ...bp,
            imageResource: replaceWithSasIfNotPublic(bp.imageResource),
            thumb: replaceWithSasIfNotPublic(bp.thumb),
        }));
    }


    if ('rubberElementPictures' in slide && typeof slide.rubberElementPictures === 'object') {
        slide.rubberElementPictures = {
            foregroundImageUrl: replaceWithSasIfNotPublic(slide.rubberElementPictures.foregroundImageUrl),
            backgroundImageUrl: replaceWithSasIfNotPublic(slide.rubberElementPictures.backgroundImageUrl)
        };
    }

    return slide;
}
